"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "citta-di-castello": {
    "92c5381f": [{
      "hkey": "ab1c2cad",
      "slug": "cinquemiglia-cornetto-promano-san-maiano",
      "name": "Cinquemiglia-Cornetto-Promano-San Maiano",
      "primary": true,
      "skipSearch": false
    }],
    "promano": [{
      "hkey": "ab1c2cad",
      "slug": "cinquemiglia-cornetto-promano-san-maiano",
      "name": "Cinquemiglia-Cornetto-Promano-San Maiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a2c9b911": [{
      "hkey": "3966e398",
      "slug": "febrecce-trestina",
      "name": "Febrecce-Trestina",
      "primary": true,
      "skipSearch": false
    }],
    "trestina": [{
      "hkey": "3966e398",
      "slug": "febrecce-trestina",
      "name": "Febrecce-Trestina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;